<template>
    <rkm-modal
        :buttons="['cancel']"
        extra-large
        hide-header
        persistent
        ref="RkmModal"
    >
        <Form :model="model" />
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

export default {
    components: { Form },
    data: () => ({
        model: null,
    }),
    methods: {
        open(item) {
            if (item) {
                this.model = {
                    observacoes: item
                }
            }

            this.$refs.RkmModal.show()
        },
    },
}
</script>